// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"4a346fc5","91":"46cdad93","312":"dec5e5fe","569":"dc3c0f64","846":"ed9f2976","864":"dc37dada"}[chunkId] + ".chunk.js";
};